import '../node_modules/bootstrap/js/dist/util';
import '../node_modules/bootstrap/js/dist/alert';
import '../node_modules/bootstrap/js/dist/button';
import '../node_modules/bootstrap/js/dist/collapse';
import '../node_modules/bootstrap/js/dist/dropdown';
import '../node_modules/bootstrap/js/dist/scrollspy';
import '../node_modules/bootstrap/js/dist/tab';
import '../node_modules/bootstrap/js/dist/modal';
// jsLibs
import '/srv/www/poultney22/public/typo3conf/ext/epbase/Resources/Public/JavaScript/frontend_editing.js';
// jsFooterLibs
// jsFiles
import '/srv/www/poultney22/public/typo3conf/ext/epbase/Resources/Public/JavaScript/lightbox.js';
import '/srv/www/poultney22/public/typo3conf/ext/epbase/Resources/Public/JavaScript/alertbanner.js';
// jsInline
